<template>
  <div class="d-flex flex-column ScheduleColumn flex-shrink-0 flex-grow-0 mr-1">

    <v-sheet color='primary white--text mb-1 pa-1 rounded dragMeColumn' elevation="1" xcontextmenu="rightClick">
      <div class="text-subtitle-2 text-center">{{ title }}</div>
    </v-sheet>

    <div class="flex-grow-1 overflow-y-auto my-1">
      
      <template v-if="false"></template>
      <v-virtual-scroll :items="[...tasks, { xid: null }]" item-height="80" bench="0" class="">
        <template #default="{item}" :sortable-id='item.xid'>
          <ScheduleTask
            :task="item" class="mx-1"
          />
        </template>
      </v-virtual-scroll>
    </div>

    <!-- LEFT CLICK POPUP (TASK MENU) -->
    <v-menu
      v-model="contextmenu.show"
      :position-x="contextmenu.x"
      :position-y="contextmenu.y"
      absolute offset-y
      ref="menu_rightclick"
    >
        <v-list dense>
          <v-list-item link><v-icon color="primary" class="mr-2">mdi-circle</v-icon>...</v-list-item>
          <!--
          <v-list-item link @click="autosort"><v-icon color="primary" class="mr-2">mdi-sort-calendar-ascending</v-icon>Auto Sort</v-list-item>
          <v-list-item link @click="clean"><v-icon color="red" class="mr-2">mdi-trash-can</v-icon>Clean Up Old Tasks</v-list-item>
        -->
        </v-list>
    </v-menu>
    
      <ScheduleTask :task="{xid: null}" class="mx-1" xmove="moveTask" />
      <EditTaskDialog ref="editTaskDialog" />

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ScheduleColumn{
  width: 300px;

}

.dragMeColumn{
  cursor: move;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
//import PrintJS from 'print-js'
import ScheduleTask from './Task'
import EditTaskDialog from '@/components/Dialogs/EditTask'

export default {
  name: 'ScheduleColumn',

  components: {
    ScheduleTask, EditTaskDialog
  },

  props: {
    taskType: { type: Object, default: null, required: true },
  },

  data(){
    return {
      tasks: [],
      sortable_: null,
      contextmenu: { show: false, x: null, y: null },
    }
  },

  computed: {
    ...mapGetters("UI", ["CONTEXT_MENU"]),
    xid(){ return this.taskType.xid; },
    title(){ return this.taskType.title; },
  },

  watch: {
    CONTEXT_MENU(component){
      this.contextmenu = { ...this.contextmenu, show: component == this.$el }
    }
  },

  methods: {
    ...mapActions("API", ['API']),
    ...mapActions("UI", ['SET_CONTEXT_MENU']),
    

    refresh(){
      this.tasks = [];
      this.API({ method: 'GET', endpoint: `priorities/tasks/not_prioritised/${this.xid}` })
      .then(tasks => { this.tasks = tasks; })
    },

    async completeTask(task){
      let pos = this.tasks.findIndex(t => t.xid == task.xid);
      if(pos == -1) return;
      await this.API({ method: 'POST', endpoint: `tasks/${task.xid}/complete` });
      this.tasks.splice(pos, 1);
      this.$emit('complete');
    },

  },

  mounted(){
    this.refresh();
  }
}
</script>
